import React from "react";
import ImageSide from "../../shared/ImageSide";
import { understandingEnergyImbalances } from "../../../data/body-coding/understanding-energy-imbalances";

const UnderstandingEnergyImbalances = () => {
	return (
		<ImageSide left={false} imageSrc="images/understanding-energy-imbalances.svg">
			<h2 className="fw-bold display-5 mb-5">{understandingEnergyImbalances.heading}</h2>
			<ul>
				{understandingEnergyImbalances.content.map((c, index) => (
					<li key={index} className="fs-5 mb-2">{c}</li>
				))}
			</ul>
		</ImageSide>
	);
};

export default UnderstandingEnergyImbalances;